import { publicRequest } from "../core/services";
const group = {
    look: (data) => publicRequest.post("/api/groups/get-groups-look", data),
    data: (data) => publicRequest.post("/api/groups/get-groups-data", data),
};
export const api = {
    group,
};
